module.exports = __webpack_public_path__ + "img/php.235de46.svg";